module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Perfection Is NOT the Word for It")]), _c('ol', {
    staticClass: "toc",
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#foreword"
    }
  }, [_vm._v("Foreword")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#chapter-1"
    }
  }, [_vm._v("Chapter 1: "), _c('span', {
    staticStyle: {
      "font-weight": "normal",
      "font-style": "italic"
    }
  }, [_vm._v("Orchestral Introduction")])]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#orchestral-introduction"
    }
  })])])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#chapter-2"
    }
  }, [_vm._v("Chapter 2: "), _c('span', {
    staticStyle: {
      "font-weight": "normal",
      "font-style": "italic"
    }
  }, [_vm._v("An Oxford Overture")])]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#an-oxford-overture"
    }
  })])])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#chapter-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: "), _c('span', {
    staticStyle: {
      "font-weight": "normal",
      "font-style": "italic"
    }
  }, [_vm._v("Albion Ensemble: Five in a Bar")])]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#albion-ensemble-five-in-a-bar",
      "title": "Link target outside of Sample"
    }
  })])])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#chapter-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: "), _c('span', {
    staticStyle: {
      "font-weight": "normal",
      "font-style": "italic"
    }
  }, [_vm._v("Trials and Errors")])]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#trials-and-errors",
      "title": "Link target outside of Sample"
    }
  })])])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#chapter-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: "), _c('span', {
    staticStyle: {
      "font-weight": "normal",
      "font-style": "italic"
    }
  }, [_vm._v("Inventing the Orchestra of the Age of Enlightenment")])]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#inventing-the-orchestra-of-the-age-of-enlightenment",
      "title": "Link target outside of Sample"
    }
  })])])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: "), _c('span', {
    staticStyle: {
      "font-weight": "normal",
      "font-style": "italic"
    }
  }, [_vm._v("Re-Inventing the English Concert")])]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#re-inventing-the-english-concert",
      "title": "Link target outside of Sample"
    }
  })])])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: "), _c('span', {
    staticStyle: {
      "font-weight": "normal",
      "font-style": "italic"
    }
  }, [_vm._v("Double Bar: When the Music Stops")])]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#double-bar-when-the-music-stops",
      "title": "Link target outside of Sample"
    }
  })])])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: "), _c('span', {
    staticStyle: {
      "font-weight": "normal",
      "font-style": "italic"
    }
  }, [_vm._v("Coda")])]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#coda",
      "title": "Link target outside of Sample"
    }
  })])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0